module.exports = __webpack_public_path__ + "static/media/micro-deposit.c51321b6.png";